import { Col, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import { Field } from "../../../../../../styles/global/Pages.styled";
import Spinner from "../../../../Atomics/Spinner";
import { Text } from "../../../../Atomics/Text";

const ItemDetailModal = ({ item, isModalVisible, handleClose, isFetching }) => {

    const { t } = useTranslation();

    const renderProperties = (properties, offset = 0) => {
        return properties?.map((property, index) => (
            <Col span={12} key={index + offset} className='d-flex'>
                <Field id={index + offset} $backgroundColor="neutral-3" className='full-width'>
                    <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{property.property}</Text>
                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{property.value && property.value !== '' ? property.value : '-'}</Text>
                </Field>
            </Col>
        ));
    };

    return (
        <Modal
            title={t("Item Details")}
            open={isModalVisible}
            width="70rem"
            onCancel={handleClose}
            footer={null}
        >
            {isFetching &&
                <div style={{ width: "100%", display: "flex", justifyContent: "center", height: "50vh", alignItems: "center" }}>
                    <Spinner stroke="green" />
                </div>
            }
            {!isFetching &&
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Text $fontColor='coolgray-10' $fontSize='text_md' $weight='bold'>{t("Mandatory Properties")}</Text>
                    </Col>
                    {item && renderProperties(item.mandatoryProperties)}
                    <Col span={24}>
                        <Text $fontColor='coolgray-10' $fontSize='text_md' $weight='bold'>{t("Optional Properties")}</Text>
                    </Col>
                    {item && renderProperties(item.optionalProperties, item.mandatoryProperties?.length)}
                </Row>
            }
        </Modal >
    );
};

export default ItemDetailModal;